export const userData = [
  {
    name: "Jan",
    "Active User": 400,
  },
  {
    name: "Feb",
    "Active User": 300,
  },
  {
    name: "Mar",
    "Active User": 200,
  },
  {
    name: "Apr",
    "Active User": 278,
  },
  {
    name: "May",
    "Active User": 189,
  },
  {
    name: "Jun",
    "Active User": 239,
  },
  {
    name: "Jul",
    "Active User": 349,
  },
  {
    name: "Aug",
    "Active User": 500,
  },
  {
    name: "Sep",
    "Active User": 950,
  },
  {
    name: "Oct",
    "Active User": 1200,
  },
  {
    name: "Nov",
    "Active User": 1560,
  },
  {
    name: "Dec",
    "Active User": 2000,
  },
];

export const userRows = [
  {
    id: 1,
    username: "Elon Musk",
    avatar:
      "https://upload.wikimedia.org/wikipedia/commons/a/a3/Elon_Musk_2019.jpg",
    email: "elonmusk@meta.com",
    status: "active",
    transaction: "₹952.00",
  },
  {
    id: 2,
    username: "Elon Musk",
    avatar:
      "https://upload.wikimedia.org/wikipedia/commons/a/a3/Elon_Musk_2019.jpg",
    email: "elonmusk@meta.com",
    status: "active",
    transaction: "₹952.00",
  },
  {
    id: 3,
    username: "Elon Musk",
    avatar:
      "https://upload.wikimedia.org/wikipedia/commons/a/a3/Elon_Musk_2019.jpg",
    email: "elonmusk@meta.com",
    status: "active",
    transaction: "₹952.00",
  },
  {
    id: 4,
    username: "Elon Musk",
    avatar:
      "https://upload.wikimedia.org/wikipedia/commons/a/a3/Elon_Musk_2019.jpg",
    email: "elonmusk@meta.com",
    status: "active",
    transaction: "₹952.00",
  },
  {
    id: 5,
    username: "Elon Musk",
    avatar:
      "https://upload.wikimedia.org/wikipedia/commons/a/a3/Elon_Musk_2019.jpg",
    email: "elonmusk@meta.com",
    status: "active",
    transaction: "₹952.00",
  },
  {
    id: 6,
    username: "Elon Musk",
    avatar:
      "https://upload.wikimedia.org/wikipedia/commons/a/a3/Elon_Musk_2019.jpg",
    email: "elonmusk@meta.com",
    status: "active",
    transaction: "₹952.00",
  },
  {
    id: 7,
    username: "Elon Musk",
    avatar:
      "https://upload.wikimedia.org/wikipedia/commons/a/a3/Elon_Musk_2019.jpg",
    email: "elonmusk@meta.com",
    status: "active",
    transaction: "₹952.00",
  },
  {
    id: 8,
    username: "Elon Musk",
    avatar:
      "https://upload.wikimedia.org/wikipedia/commons/a/a3/Elon_Musk_2019.jpg",
    email: "elonmusk@meta.com",
    status: "active",
    transaction: "₹952.00",
  },
  {
    id: 9,
    username: "Elon Musk",
    avatar:
      "https://upload.wikimedia.org/wikipedia/commons/a/a3/Elon_Musk_2019.jpg",
    email: "elonmusk@meta.com",
    status: "active",
    transaction: "₹952.00",
  },
  {
    id: 10,
    username: "Elon Musk",
    avatar:
      "https://upload.wikimedia.org/wikipedia/commons/a/a3/Elon_Musk_2019.jpg",
    email: "elonmusk@meta.com",
    status: "active",
    transaction: "₹952.00",
  },
];

// chartData.js
export const uData = [2000, 3800, 4836, 3903, 6950, 10000];

export const xLabels = ["2019", "2020", "2021", "2022", "2023", "2024"];

// genderData.js
export const genderData = [
  { label: "Male", value: 680 },
  { label: "Female", value: 300 },
  { label: "Others", value: 20 },
];


// salesData
export const data = [15, 20, 16, 21];
export const labels = ["Jan", "Feb", "Mar", "Apr"];


//forecastData
export const forecastData = [500000, 247190];
export const forecastLabels = ["Revenue", "Pending Forecast"];
export const forecastLegendData = [
  { label: "Revenue", color: "#2196F3" },
  { label: "Pending Forecast", color: "#4CAF50" },
];


export const salesData = {
  totalRevenue: 12000,
  quarterlyGrowth: 15.5, // in percentage
  annualGrowth: 10.2, // in percentage
  netProfit: 4000,
  revenueOverTime: [3000, 3200, 2800, 3600], // quarterly revenue
  quarters: ["Q1", "Q2", "Q3", "Q4"],
};